import dayjs, { Dayjs } from 'dayjs';
import { ENG_TO_ESP_MONTH } from './constants';
import { capitalize } from './string';
import { ENGLISH_MONTH, SPANISH_MONTH } from './types';

export const ONE_MINUTE_MS = 1000;

export const FORMAT_DATE_1 = `DD/MM/YYYY`;

export const formatDate = (
  date: string | number,
  config?: { time: boolean; timeCase?: formatDateCaseType }
) => {
  const dayJs =
    typeof date === 'string' && /^\d+$/.test(date)
      ? dayjs.unix(parseInt(date) / 1000)
      : dayjs(date);
  return formatDayJsDate(dayJs, config);
};

export const formatDayJsDate = (
  dayJs: Dayjs,
  config?: { time: boolean; timeCase?: formatDateCaseType }
) => {
  const showTime = config?.time;
  const timeCase = config?.timeCase || formatDateCaseEnum.UPPER;

  const timeCaseDisplay = timeCase === formatDateCaseEnum.UPPER ? 'A' : 'a';
  const onlyDateFormat = FORMAT_DATE_1;
  const dateAndTimeFormat = `${FORMAT_DATE_1}, hh:mm ${timeCaseDisplay}`;
  const displayFormat = showTime ? dateAndTimeFormat : onlyDateFormat;

  return dayJs.format(displayFormat);
};

export enum formatDateCaseEnum {
  UPPER = 'uppercase',
  LOWER = 'lowercase',
}
export type formatDateCaseType = 'uppercase' | 'lowercase';

export const safeParseDate = (input: string): Date | undefined => {
  try {
    const timestamp = Date.parse(input);
    if (isNaN(timestamp)) return undefined;
    return new Date(timestamp);
  } catch {
    return undefined;
  }
};

export function getCurrentTimestamp() {
  const timestamp = new Date().getTime();
  return timestamp;
}

export const GetMonthNameDate = (epochTime: number | string) => {
  const epoch = epochTime?.toString().split(' ');
  // if epoch is in milliseconds directly use new Date else get the right formatted date.
  const utcDate =
    epoch?.length > 1
      ? new Date(`${epoch[0]} ${epoch[1]}`)
      : new Date(epoch[0]);
  const monthString = utcDate.toLocaleString('en-US', { month: 'short' });
  const capitalized = capitalize(monthString);
  const result = `${utcDate.getDate()} ${capitalized}, ${utcDate.getFullYear()}`;
  return result;
};

export const GET_SPANISH_MONTH = (month: ENGLISH_MONTH) => {
  return ENG_TO_ESP_MONTH[month] as SPANISH_MONTH;
};
